module.exports = __webpack_public_path__ + "static/media/ic-mob-dropdown.ce84abfa.svg";